export default {
  th: {
    overview: {
      title: "ภาพรวมธุรกิจ",
      subtitle: "สรุปสถานะปัจจุบันและธุรกรรมตามช่วงวันที่เลือก",
      updated: "ข้อมูลอัปเดต ณ",
      scope: "ขอบเขตข้อมูล",
      snapshot: "สถานะปัจจุบัน",
      active: "ตั๋วทั้งหมดในระบบ",
      defer: "ตั๋วผลัดทั้งหมด",
      represent: "ใช้ลายนิ้วมือผู้มีอำนาจ",
      outage: "ตั๋วขัดข้อง / ไฟดับ",
      line: "ลูกค้า LINE OA",
      tickets: "เบอร์",
      accounts: "บัญชี",
      period: "ผลงานในช่วงเวลา",
      periodHint: "ข้อมูลด้านล่างเปลี่ยนตามช่วงวันที่เลือก",
      today: "วันนี้",
      week: "7 วันล่าสุด",
      month: "เดือนนี้",
      from: "วันที่เริ่มต้น",
      to: "วันที่สิ้นสุด",
      apply: "แสดงผล",
      required: "กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุด",
      reversed: "วันที่สิ้นสุดต้องไม่อยู่ก่อนวันที่เริ่มต้น",
      future: "ไม่สามารถเลือกวันที่ในอนาคตได้",
      limit: "เลือกช่วงวันที่ย้อนหลังได้ไม่เกิน 3 เดือน",
      incoming: "ยอดตั๋วจำนำเข้า",
      outgoing: "ยอดตั๋วไถ่ถอนออก",
      interest: "รายได้ดอกเบี้ยรวม",
      ticketNet: "ส่วนต่างมูลค่าตั๋ว",
      million: "ล้านบาท",
      baht: "บาท",
      newTickets: "ตั๋วที่ออกใหม่",
      closedTickets: "ตั๋วเดิมที่ปิด",
      normalInterest: "จากธุรกรรมปกติในช่วงวันที่เลือก",
      interestBelow: "ดูองค์ประกอบรายได้ด้านล่าง",
      ticketFormula: "ยอดตั๋วออก − ยอดตั๋วเข้า",
      stockNet: "สต๊อกสุทธิ",
      ticketValue: "มูลค่าตั๋ว",
      cashflow: "กระแสเงินสด · รายรับ–รายจ่าย",
      cashHint: "ยอดเงินรับเข้าและจ่ายออกตามสาขาและช่วงวันที่เลือก",
      receive: "รายรับรวม",
      pay: "รายจ่ายรวม",
      cashNet: "กระแสเงินสดสุทธิ",
      cashFormula: "รายรับ − รายจ่าย",
      cashNote: "กระแสเงินสดสุทธิไม่ใช่กำไรหรือยอดเงินคงเหลือ",
      compareCash: "เปรียบเทียบเงินรับเข้า–จ่ายออก",
      cashUnit: "หน่วย: บาท",
      zeroCash: "ไม่มีรายการรับ–จ่ายในช่วงที่เลือก",
      transactions: "สัดส่วนธุรกรรม",
      transactionHint: "เปรียบเทียบกิจกรรมหลักของสาขา",
      count: "จำนวน",
      items: "รายการ",
      normal: "ธุรกรรมปกติ",
      interestSources: "รายได้ดอกเบี้ยมาจากไหน",
      interestHint: "แยกตามประเภทธุรกรรมปกติ",
      zero: "ไม่มีข้อมูลในช่วงวันที่เลือก",
      drillHint: "เลือกประเภทธุรกรรมเพื่อดูรายละเอียด",
      pawn: "จำนำ",
      renew: "ต่อดอก",
      increase: "เพิ่มต้น",
      reduce: "ลดต้น",
      redeem: "ไถ่ถอน",
      usage: "การใช้งานในช่วงวัน",
      customers: "ลูกค้าเข้าทำธุรกรรม",
      cancel: "ตั๋วเสีย",
      terminate: "ธุรกรรมยกเลิก",
      edit: "แก้ไขข้อมูลทรัพย์",
      otp: "ใช้ OTP",
      otpKinds: "ปกติ / ย้ายระบบ",
      details: "รายละเอียดธุรกรรม",
      detailsHint: "จำนวน มูลค่าตั๋ว และดอกเบี้ย ในมุมมองเดียว",
      expandDetails: "แสดงรายละเอียดธุรกรรม",
      collapseDetails: "ซ่อนรายละเอียดธุรกรรม",
      showMigration: "แสดงรายการย้ายระบบ",
      type: "ประเภทธุรกรรม",
      interestColumn: "ดอกเบี้ย",
      total: "รวม",
      migration: "ย้ายระบบ",
      missingInterest: "ไม่มีข้อมูลดอกเบี้ยแยกรายการย้ายระบบ",
      legacy: "ข้อมูลสำหรับระบบเก่า",
      graph: "Graph",
      data: "Data",
      normalSummary: "สรุปภาพรวมธุรกรรมปกติ",
      migrationSummary: "สรุปภาพรวมธุรกรรมย้ายระบบ",
      diff: "ส่วนต่างยอดยกมา",
      allTickets: "รวมมูลค่าตั๋วทั้งหมด",
      allInterest: "รวมมูลค่าดอกเบี้ยทั้งหมด",
      pawnIncrease: "จำนำ,เพิ่มต้น",
      otherTypes: "ต่อดอก,ลดต้น,ไถ่ถอน",
      loading: "กำลังโหลดข้อมูล…",
      chooseShop: "กรุณาเลือกสาขาเพื่อแสดงข้อมูล",
      loadError: "โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่",
      retry: "ลองใหม่",
      info: "ความหมายของตัวเลข",
      openDetails: "เปิดรายละเอียด",
      close: "ปิด",
      components: "องค์ประกอบของยอด",
      transactionDetailInfo:
        "รายละเอียดสรุปของธุรกรรมปกติในขอบเขตข้อมูลและช่วงวันที่ที่เลือก",
      migrationDetailInfo:
        "รายละเอียดสรุปของรายการย้ายระบบในขอบเขตข้อมูลและช่วงวันที่ที่เลือก โดยระบบเดิมไม่มีข้อมูลดอกเบี้ยแยกรายการ",
      incomingInfo:
        "รวมมูลค่าตั๋วใหม่จากจำนำ ต่อดอก เพิ่มต้น ลดต้น และรายการย้ายระบบ",
      outgoingInfo:
        "มูลค่าตั๋วเดิมที่ปิด โดยปรับส่วนต่างเงินต้นสำหรับเพิ่มต้นและลดต้น ไม่ใช่เฉพาะรายการไถ่ถอน",
      interestInfo:
        "ผลรวมดอกเบี้ยจากต่อดอก เพิ่มต้น ลดต้น และไถ่ถอนของธุรกรรมปกติ",
      ticketNetInfo:
        "ยอดตั๋วออก − ยอดตั๋วเข้า เป็นส่วนต่างมูลค่าเอกสาร ไม่ใช่กำไรหรือกระแสเงินสดสุทธิ",
      lineNote: "จำนวนบัญชี LINE OA รวมรายสาขา อาจมีบัญชีเดียวกันในหลายสาขา",
      partialLine: "ข้อมูล LINE OA ไม่ครบ",
      unavailable: "ยังไม่มีข้อมูล",
      tableTotal: "รวมรายการที่แสดง",
    },
  },
  en: {
    overview: {
      title: "Business overview",
      subtitle: "Current status and transactions for the selected period",
      updated: "Updated at",
      scope: "Data scope",
      snapshot: "Current status",
      active: "Active tickets",
      defer: "Extended tickets",
      represent: "Authorized fingerprints",
      outage: "Outage tickets",
      line: "LINE OA customers",
      tickets: "tickets",
      accounts: "accounts",
      period: "Period performance",
      periodHint: "Figures below follow the selected period",
      today: "Today",
      week: "Last 7 days",
      month: "This month",
      from: "From date",
      to: "To date",
      apply: "Apply",
      required: "Select both dates",
      reversed: "End date must not precede start date",
      future: "Future dates are not available",
      limit: "Dates must be within the last 3 months",
      incoming: "Incoming ticket value",
      outgoing: "Closed ticket value",
      interest: "Total interest income",
      ticketNet: "Ticket value difference",
      million: "million THB",
      baht: "THB",
      newTickets: "New tickets",
      closedTickets: "Closed tickets",
      normalInterest: "From regular transactions in the selected period",
      interestBelow: "See interest breakdown below",
      ticketFormula: "Closed value − incoming value",
      stockNet: "Net ticket count",
      ticketValue: "Ticket value",
      cashflow: "Cashflow · Receipts and payments",
      cashHint:
        "Recorded receipts and payments for the selected scope and dates",
      receive: "Total receipts",
      pay: "Total payments",
      cashNet: "Net cashflow",
      cashFormula: "Receipts − payments",
      cashNote: "Net cashflow is not profit or a closing cash balance",
      compareCash: "Receipts versus payments",
      cashUnit: "Unit: THB",
      zeroCash: "No payments recorded for this period",
      transactions: "Transaction breakdown",
      transactionHint: "Compare branch activities",
      count: "Count",
      items: "transactions",
      normal: "Regular transactions",
      interestSources: "Interest income sources",
      interestHint: "By regular transaction type",
      zero: "No data for the selected period",
      drillHint: "Select a transaction type to see details",
      pawn: "Pawn",
      renew: "Renew",
      increase: "Increase principal",
      reduce: "Reduce principal",
      redeem: "Redeem",
      usage: "Activity in the period",
      customers: "Transacting customers",
      cancel: "Void tickets",
      terminate: "Cancelled transactions",
      edit: "Asset information edits",
      otp: "OTP use",
      otpKinds: "Regular / migrated",
      details: "Transaction details",
      detailsHint: "Count, ticket value and interest together",
      expandDetails: "Show transaction details",
      collapseDetails: "Hide transaction details",
      showMigration: "Show migrated transactions",
      type: "Transaction type",
      interestColumn: "Interest",
      total: "Total",
      migration: "Migrated",
      missingInterest: "Interest breakdown is unavailable for migrated rows",
      legacy: "Legacy system data",
      graph: "Graph",
      data: "Data",
      normalSummary: "Regular transaction summary",
      migrationSummary: "Migrated transaction summary",
      diff: "Principal difference",
      allTickets: "Total ticket value",
      allInterest: "Total interest value",
      pawnIncrease: "Pawn, increase",
      otherTypes: "Renew, reduce, redeem",
      loading: "Loading…",
      chooseShop: "Select a branch to load data",
      loadError: "Unable to load data. Please try again.",
      retry: "Retry",
      info: "About these figures",
      openDetails: "Open details",
      close: "Close",
      components: "Amount breakdown",
      transactionDetailInfo:
        "Summary of regular transactions for the selected scope and period.",
      migrationDetailInfo:
        "Summary of migrated transactions for the selected scope and period. Per-transaction interest is unavailable from the legacy system.",
      incomingInfo:
        "New ticket face values from pawn, renewal, increase, reduction and migration.",
      outgoingInfo:
        "Closed ticket face values, adjusted for principal changes. Includes more than redemptions.",
      interestInfo:
        "Interest from regular renewals, increases, reductions and redemptions.",
      ticketNetInfo:
        "Closed minus incoming ticket face value; not profit or net cashflow.",
      lineNote:
        "LINE OA accounts summed by branch; the same account may occur in multiple branches.",
      partialLine: "Incomplete LINE OA data",
      unavailable: "Unavailable",
      tableTotal: "Total displayed rows",
    },
  },
};
